export default __webpack_public_path__ + "media/components/AdEdit/images/facebook-planet-6a17d9df8aa42bdebd213cfa00daa4c1.png";